import { useTranslation } from 'react-i18next';

import { GiftIcon } from '../ui';
import { formatUsd } from '../../lib/format';
import type { ReferralEarningItem } from '../../lib/types';

interface Props {
  earning: ReferralEarningItem;
  locale?: string;
}

export function EarningRow({ earning: e, locale = 'en-US' }: Props) {
  const { t } = useTranslation();
  const friend = e.source_user_tg_username
    ? `@${e.source_user_tg_username}`
    : locale.startsWith('ru')
      ? 'Друг'
      : 'Friend';
  const dt = new Date(e.created_at);
  const dateLabel = dt.toLocaleDateString(locale, {
    day: '2-digit',
    month: 'short',
  });
  const timeLabel = dt.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  });
  return (
    <div className="flex items-start gap-3 px-4 py-3.5">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-pb-accent-soft text-pb-accent">
        <GiftIcon size={16} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <span className="text-[14px] font-medium text-tg-text">{friend}</span>
          <span className="text-[11px] text-tg-hint">L{e.level}</span>
        </div>
        <p className="pb-caption mt-0.5 leading-snug">
          {dateLabel} · {timeLabel} · {e.pct_applied}% ·{' '}
          {t(`referrals.source_kind.${e.source_kind}`, {
            defaultValue: e.source_kind,
          })}
          {!e.paid_tx_hash ? (
            <>
              {' · '}
              <span className="text-tg-hint">
                {t('referrals.pending_payout')}
              </span>
            </>
          ) : null}
        </p>
      </div>
      <span className="pb-numeral shrink-0 text-[14px] text-pb-success">
        +{formatUsd(e.amount_usd)}
      </span>
    </div>
  );
}
